import { ArrowLeft } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { media } from '@/utils/mediaQueries';

/**
 * Tekstowy link powrotu nad tytułem strony (karty szczegółów, formularze edycji).
 * Celowo nie jest przyciskiem CTA: to nawigacja wstecz, a nie akcja na danych.
 */
const LinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  padding: 0;
  border: 0;
  background: none;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    text-decoration: underline;
  }

  /* Telefon: odstęp od paska górnego i od tytułu, wyższe pole dotyku. */
  ${media.mobile} {
    min-height: 32px;
    margin: 8px 0 12px;
  }
`;

interface BackLinkProps {
  onClick: () => void;
  label?: string;
  className?: string;
}

export const BackLink: FC<BackLinkProps> = ({ onClick, label, className }) => {
  const { t } = useTranslation();
  return (
    <LinkButton type="button" onClick={onClick} className={className}>
      <ArrowLeft size={14} strokeWidth={2} />
      {label ?? t('common.back', 'Powrót')}
    </LinkButton>
  );
};
